import { j as s } from "../accordion/Accordion-CrPiD_81.mjs";
const a = ({ className: e = "", innerClassName: r = "", children: t, ...d }) => /* @__PURE__ */ s.jsx("li", { className: `rds-list__item__ordered ${e}`, "data-testid": "rds-ordered-list-item", ...d, children: /* @__PURE__ */ s.jsx("span", { className: `${r}`, children: t }) });
export {
  a as O
};
